/* eslint-disable no-console */
<template>
  <div>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="220px"
      :disabled="parentData.isDetail || !submitShow"
    >
      <div class="mode_box">
        <div class="card_info">身份证信息</div>

        <!-- 必填 -->
        <el-row style="padding-right:80px;">
          <el-col :span="8">
            <el-form-item label="姓名">
              <el-input v-model="form.name" placeholder="姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出生年月" prop="birthDate">
              <!-- <el-input
                v-model="form.birth"
                placeholder="请输入出生年月"
                clearable
              /> -->
              <!-- 日期 -->
              <el-date-picker
                v-model="form.birth"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="form.sex" placeholder="请选择性别" clearable>
                <el-option :value="1" label="男" />
                <el-option :value="2" label="女" />
              </el-select>
            </el-form-item>
          </el-col>
          <!--   <el-col :span="8">
              <el-form-item label="性别" prop="sex">
                <el-input
                  v-model="form.sex"
                  placeholder="请输入性别"
                  clearable
                />
              </el-form-item>
            </el-col>-->
          <el-col :span="8">
            <el-form-item label="手机号码" prop="phone">
              <el-input
                v-model="form.phone"
                placeholder="请输入手机号码"
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="民族" prop="nationality">
              <el-input
                v-model="form.nationality"
                placeholder="请输入民族"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="签发机关" prop="idCardIssuingOrgan">
              <el-input
                v-model="form.idCardIssuingOrgan"
                placeholder="请输入签发机关"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="住址" prop="homeAddress">
              <el-input
                autosize
                type="textarea"
                v-model="form.homeAddress"
                placeholder="请输入住址"
                clearable
                maxlength="90"
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="公民身份证号码" prop="identificationNumber">
              <el-input
                v-model="form.identificationNumber"
                placeholder="请输入公民身份证号码"
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="身份证有效期" prop="idCardDueDate">
              <el-date-picker
                v-model="form.idCardDueDate"
                :class="form.hasDueDate ? 'disabledhide' : ''"
                type="date"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="长期" label-width="60px">
              <el-checkbox
                v-model="form.hasDueDate"
                @change="
                  value => {
                    this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                  }
                "
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传证件">
              <ImgReview
                lebal="实际承运人身份证人像面照片"
                :src="form.identificationImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '实际承运人身份证人像面照片',
                  prefix: 'identification',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.identificationImg"
                v-else
              />
              <ImgReview
                lebal="实际承运人身份证国徽面照片"
                :src="form.identificationBackImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '实际承运人身份证国徽面照片',
                  prefix: 'identificationBack',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.identificationBackImg"
                v-else
              />
              <!-- <ImgReview lebal="实际承运人半身照" :src="form.driverImg" error="未上传" />

            <ImgReview lebal="机动车驾驶证照片" :src="form.driverLicenseImg" error="未上传" />
            <ImgReview lebal="道路运输从业资格证照片" :src="form.workLicenseImg" error="未上传" />
            <ImgReview lebal="安全责任险照片" :src="form.safeDutyInsureImg" error="未上传" /> -->
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="mode_box" :class="{ pitch_on: !!form.driverIsup }">
        <div class="card_info">其他证件信息</div>
        <div class="card_type_title">机动车驾驶证</div>
        <el-row style="padding-right:80px;">
          <el-col :span="8">
            <el-form-item label="驾驶证号" prop="driverLicense">
              <el-input
                v-model="form.driverLicense"
                placeholder="请输入机动车驾驶证号"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="档案编号" prop="fileNo">
              <el-input
                v-model="form.fileNo"
                placeholder="请输入档案编号"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发证机关" prop="driverIssuingOrganizations">
              <el-input
                v-model="form.driverIssuingOrganizations"
                placeholder="请输入机动车驾驶证发证机关"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="准驾类型" prop="vehicleClass">
              <el-select
                v-model="form.vehicleClass"
                placeholder="请选择准驾类型"
                clearable
              >
                <el-option
                  v-for="item in parentData.vehicleTypeAllowList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="有效期自" prop="driverLicenseFromDate">
              <el-date-picker
                v-model="form.driverLicenseFromDate"
                type="date"
                placeholder="请选择机动车驾驶证有效期开始日期"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="初次领证日期" prop="firstIssueDate">
              <el-date-picker
                v-model="form.firstIssueDate"
                type="date"
                placeholder="请输入机动车驾驶证初次领证日期"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="有效期至" prop="driverLicenseDueDate">
              <el-date-picker
                v-model="form.driverLicenseDueDate"
                :class="form.hasDriverDueDate ? 'disabledhide' : ''"
                type="date"
                placeholder="请选择机动车驾驶证有效期结束日期"
                value-format="yyyy-MM-dd"
                clearable
                :disabled="form.hasDriverDueDate"
              />
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="长期" label-width="60px">
              <el-checkbox
                v-model="form.hasDriverDueDate"
                @change="
                  value => {
                    this.$set(
                      form,
                      'driverLicenseDueDate',
                      value ? '9999-12-31' : ''
                    );
                  }
                "
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传证件">
              <ImgReview
                lebal="机动车驾驶证照片"
                :src="form.driverLicenseImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '机动车驾驶证照片',
                  prefix: 'driverLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.driverLicenseImg"
                v-else
              />
              <ImgReview
                lebal="机动车驾驶证副页照片"
                :src="form.driverLicenseBackImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '机动车驾驶证副页照片',
                  prefix: 'driverLicenseBack',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.driverLicenseBackImg"
                v-else
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="card_type_title" style="margin-top:15px;">
          道路运输从业资格证
        </div>
        <el-row style="padding-right:80px;">
          <el-col :span="13">
            <el-form-item label="资格证号" prop="workLicense">
              <template slot="label">
                资格证号
                <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="注:总质量4.5吨及以下普通货运车辆从事普通货物运输经营的驾驶员可填驾驶员身份证前6位+000000000000"
                    placement="top"
                  >
                    <i
                      class="el-icon-question"
                      style="margin-left: 4px;cursor: pointer;"
                    ></i>
                  </el-tooltip> -->
              </template>
              <el-input
                v-model="form.workLicense"
                placeholder="请输入道路运输从业资格证号"
                clearable
              />
              <div class="remarks">
                注:总质量4.5吨及以下普通货运车辆从事普通货物运输经营的驾驶员可填驾驶员身份证前6位+000000000000
              </div>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
          <el-form-item
            label="道路运输从业资格证准驾车型"
            prop="approvedDriving"
          >
            <el-input
              v-model="form.approvedDriving"
              placeholder="请输入道路运输从业资格证准驾车型"
              clearable
            />
          </el-form-item>
        </el-col> -->
          <el-col :span="11">
            <el-form-item label="资格类别" prop="qualificationCategory">
              <el-input
                v-model="form.qualificationCategory"
                placeholder="请输入道路运输从业资格证从业资格类别"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item label="初次领证日期" prop="initialCertificationDate">
              <el-date-picker
                v-model="form.initialCertificationDate"
                type="date"
                placeholder="初次领证日期"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="到期日期" prop="workLicenseDueDate">
              <el-date-picker
                v-model="form.workLicenseDueDate"
                type="date"
                placeholder="请选择道路运输从业资格证到期日期"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传证件">
              <ImgReview
                lebal="道路运输从业资格证照片"
                :src="form.workLicenseImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '道路运输从业资格证照片',
                  prefix: 'workLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.workLicenseImg"
                v-else
              />
              <ImgReview
                lebal="道路运输从业资格证照片(副页)"
                :src="form.workLicenseDeputyImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '道路运输从业资格证照片(副页)',
                  prefix: 'workLicenseDeputy',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.workLicenseDeputyImg"
                v-else
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!-- todo -->
      <!-- 上传 身份证正反面-->
      <!-- <el-row v-if="!parentData.isDetail && submitShow">
        <el-col :span="24">
          <el-form-item label="上传证件">
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人身份证人像面照片',
                prefix: 'identification',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.identificationImg"
              @handleImgSuccess="ficationImgSuccess"
            />
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人身份证国徽面照片',
                prefix: 'identificationBack',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.identificationBackImg"
              @handleImgSuccess="ficationImgBackSuccess"
            />
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row v-else>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <ImgReview
              lebal="实际承运人身份证人像面照片"
              :src="form.identificationImg"
              error="未上传"
            />
            <ImgReview
              lebal="实际承运人身份证国徽面照片"
              :src="form.identificationBackImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- 身份证信息 -->
      <el-row>
        <!-- <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model.trim="form.name"
              placeholder="请输入姓名"
              clearable
              @change="
                value => {
                  form.name = value.replace(/\s/g, '');
                }
              "
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col v-if="reportProvinceName == 'jiangsu'" :span="12">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="form.sex" placeholder="请选择性别" clearable>
              <el-option :value="1" label="男" />
              <el-option :value="2" label="女" />
            </el-select>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="联系方式" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入联系方式"
              autocomplete="off"
              clearable
              disabled
            />
          </el-form-item>
        </el-col> -->
        <!-- 解决自动填充问题 -->
        <!-- <el-col :span="12">
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              style="position: fixed; bottom: -9999px"
            />
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="new-password"
              placeholder="请输入密码，默认abcd1234"
              clearable
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="工作单位" prop="workCompany">
            <el-input
              v-model="form.workCompany"
              placeholder="请输入工作单位"
              clearable
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="公民身份证号码" prop="identificationNumber">
            <el-input
              v-model="form.identificationNumber"
              placeholder="请输入公民身份证号码"
              clearable
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="9">
          <el-form-item label="身份证有效期" prop="idCardDueDate">
            <el-date-picker
              v-model="form.idCardDueDate"
              :class="form.hasDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择身份证有效期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDueDate"
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDueDate"
              @change="
                value => {
                  this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                }
              "
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="通信地址" prop="areaList">
            <el-cascader
              v-model="form.areaList"
              :options="parentData.areaOptions"
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children',
              }"
              clearable
              @change="changeAreaList"
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="住址" prop="homeAddress">
            <el-input
              v-model="form.homeAddress"
              placeholder="请输入住址"
              clearable
            />
          </el-form-item>
        </el-col> -->
      </el-row>
      <!-- 上传  机动车驾驶证-->
      <!-- <el-row v-if="!parentData.isDetail && submitShow">
        <el-col :span="24">
          <el-form-item label="上传证件">
            <div style="display: inline-block">
              <ImgUpload
                :upload-config="{
                  lebal: '机动车驾驶证照片',
                  prefix: 'driverLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.driverLicenseImg"
                @handleImgSuccess="driverLicenseSuccess"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '机动车驾驶证副页照片',
                  prefix: 'driverLicenseBack',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.driverLicenseBackImg"
                @handleImgSuccess="driverLicenseSuccess"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row v-else>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <div style="display: inline-block">
              <ImgReview
                lebal="机动车驾驶证照片"
                :src="form.driverLicenseImg"
                error="未上传"
              />
              <ImgReview
                lebal="机动车驾驶证副页照片"
                :src="form.driverLicenseBackImg"
                error="未上传"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <!-- <el-col :span="12">
          <el-form-item label="机动车驾驶证号" prop="driverLicense">
            <el-input
              v-model="form.driverLicense"
              placeholder="请输入机动车驾驶证号"
              clearable
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="档案编号" prop="fileNo">
            <el-input
              v-model="form.fileNo"
              placeholder="请输入档案编号"
              clearable
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item
            label="机动车驾驶证发证机关"
            prop="driverIssuingOrganizations"
          >
            <el-input
              v-model="form.driverIssuingOrganizations"
              placeholder="请输入机动车驾驶证发证机关"
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="准驾类型" prop="vehicleClass">
            <el-select
              v-model="form.vehicleClass"
              placeholder="请选择准驾类型"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleTypeAllowList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="机动车驾驶证初次领证日期" prop="firstIssueDate">
            <el-date-picker
              v-model="form.firstIssueDate"
              type="date"
              placeholder="请选择机动车驾驶证初次领证日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item
            label="机动车驾驶证有效期自"
            prop="driverLicenseFromDate"
          >
            <el-date-picker
              v-model="form.driverLicenseFromDate"
              type="date"
              placeholder="请选择机动车驾驶证有效期开始日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            label="机动车驾驶证有效期至"
            prop="driverLicenseDueDate"
          >
            <el-date-picker
              v-model="form.driverLicenseDueDate"
              :class="form.hasDriverDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择机动车驾驶证有效期结束日期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDriverDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDriverDueDate"
              @change="
                value => {
                  this.$set(
                    form,
                    'driverLicenseDueDate',
                    value ? '9999-12-31' : ''
                  );
                }
              "
            />
          </el-form-item>
        </el-col> -->
      </el-row>
      <!-- 上传  道路运输从业资格证照片-->
      <!-- <el-row v-if="!parentData.isDetail && submitShow">
        <el-col :span="24">
          <el-form-item label="上传证件">
            <div style="display: inline-block">
              <ImgUpload
                :upload-config="{
                  lebal: '道路运输从业资格证照片',
                  prefix: 'workLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="!!requireData.workLicenseImg"
                @handleImgSuccess="workLicenseSuccess"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row v-else>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <div style="display: inline-block">
              <ImgReview
                lebal="道路运输从业资格证照片"
                :src="form.workLicenseImg"
                error="未上传"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="道路运输从业资格证号" prop="workLicense">
            <el-input
              v-model="form.workLicense"
              placeholder="请输入道路运输从业资格证号"
              clearable
              @change="
                value => {
                  form.workLicense = value.replace(/\W/g, '');
                }
              "
            />
            <div class="remarks">
              注:总质量4.5吨及以下普通货运车辆从事普通货物运输经营的驾驶员可填驾驶员身份证前6位+000000000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输从业资格证从业资格类别"
            prop="qualificationCategory"
          >
            <el-input
              v-model="form.qualificationCategory"
              placeholder="请输入道路运输从业资格证从业资格类别"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <br />
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输从业资格证初次领证日期"
            prop="initialCertificationDate"
          >
            <el-date-picker
              v-model="form.initialCertificationDate"
              type="date"
              placeholder="请选择道路运输从业资格证初次领证日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输从业资格证到期日期"
            prop="workLicenseDueDate"
          >
            <el-date-picker
              v-model="form.workLicenseDueDate"
              type="date"
              placeholder="请选择道路运输从业资格证到期日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- 上传  道路运输经营许可证照片-->
      <!-- <el-row v-if="!parentData.isDetail && submitShow">
        <el-col :span="24">
          <el-form-item label="车辆证件">
            <div style="display: inline-block">
              <ImgUpload
                :upload-config="{
                  lebal: '道路运输经营许可证照片',
                  prefix: 'roadPermitNumber',
                  form: form,
                  suffix: 'Img',
                }"
                :parent-data="parentData"
                :required="!!requireData.roadPermitNumberImg"
                @handleImgSuccess="roadPermitNumberSuccess"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- 详情图片选择 -->
      <!-- <el-row v-else>
        <el-col :span="24">
          <el-form-item label="车辆证件">
            <div style="display: inline-block">
              <ImgReview
                lebal="道路运输经营许可证照片"
                :src="form.roadPermitNumberImg"
                error="未上传"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="道路经营许可证业户名称" prop="roadPermitName">
            <el-input
              v-model="form.roadPermitName"
              placeholder="请输入道路经营许可证业户名称"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输经营许可证号" prop="roadPermitNumber">
            <el-input
              v-model="form.roadPermitNumber"
              placeholder="请输入道路运输经营许可证号"
              clearable
              @change="
                (value) => {
                  form.roadPermitNumber = value.replace(/\W/g, '');
                }
              "
            />
            <div class="remarks">
              注:总质量4.5吨及以下普通货运车辆的可填车籍地6位行政区域代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输经营许可证经营范围" prop="businessScope">
            <el-input
              v-model="form.businessScope"
              placeholder="请输入道路运输经营许可证经营范围"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输经营许可证证件有效期"
            prop="periodValidity"
          >
            <el-input
              v-model="form.periodValidity"
              placeholder="请输入道路运输经营许可证证件有效期"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- 上传  车辆行驶证正页，反页照片-->
      <!-- <el-row v-if="!parentData.isDetail && submitShow">
        <el-col :span="24">
          <el-form-item label="车辆证件">
            <div style="display: inline-block">
              <ImgUpload
                :upload-config="{
                  lebal: '车辆行驶证正页照片',
                  prefix: 'vehicleLicense',
                  form: form,
                  suffix: 'Img',
                }"
                :parent-data="parentData"
                :required="!!requireData.vehicleLicenseImg"
                @handleImgSuccess="vehicleLicenseSuccess"
              />
            </div>
            <div style="display: inline-block">
              <ImgUpload
                :upload-config="{
                  lebal: '车辆行驶证副页照片',
                  prefix: 'vehicleLicenseDeputyPage',
                  form: form,
                  suffix: 'Img',
                }"
                :parent-data="parentData"
                :required="!!requireData.vehicleLicenseDeputyPageImg"
                @handleImgSuccess="vehicleLicenseBackSuccess"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- 详情图片选择 -->
      <!-- <el-row v-else>
        <el-col :span="24">
          <el-form-item label="车辆证件">
            <div style="display: inline-block">
              <ImgReview
                lebal="车辆行驶证正页照片"
                :src="form.vehicleLicenseImg"
                error="未上传"
              />
            </div>
            <div style="display: inline-block">
              <ImgReview
                lebal="车辆行驶证副页照片"
                :src="form.vehicleLicenseDeputyPageImg"
                error="未上传"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="号牌号码" prop="licenseNumber">
            <el-input
              v-model="form.licenseNumber"
              placeholder="请输入号牌号码"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆类型" prop="classificationCode">
            <el-select
              v-model="form.classificationCode"
              placeholder="请选择车辆类型"
              clearable
              filterable
              @change="isVehicleType"
            >
              <el-option
                v-for="item in parentData.vehicleClassificationList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              form.isHasTrailer == 1 ? '车头整备质量(kg)' : '车辆总质量(kg)'
            "
            prop="totalWeight"
          >
            <el-input
              v-model="form.totalWeight"
              type="number"
              :placeholder="
                form.isHasTrailer == 1
                  ? '请输入车头整备质量'
                  : '请输入车辆总质量'
              "
              clearable
              @change="(value) => setkey(value, 'totalWeight')"
              @mousewheel.native.prevent
              @DOMMouseScroll.native.prevent
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              form.isHasTrailer == 1 ? '准牵引总质量(kg)' : '核定载质量(kg)'
            "
            prop="loadWeight"
          >
            <el-input
              v-model="form.loadWeight"
              type="number"
              :placeholder="
                form.isHasTrailer == 1
                  ? '请输入准牵引总质量'
                  : '请输入核定载质量'
              "
              clearable
              @change="(value) => setkey(value, 'loadWeight')"
              @mousewheel.native.prevent
              @DOMMouseScroll.native.prevent
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-col :span="12">
            <el-form-item class="dif" prop="length" label="外廓尺寸mm">
              <el-input
                v-model="form.length"
                type="number"
                placeholder="请输入车辆长度"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="dif" prop="width" label-width="10px">
              *
              <el-input
                v-model="form.width"
                style="padding-left: 6px; box-sizing: border-box"
                placeholder="请输入车辆宽度"
                clearable
                @change="(value) => setkey(value, 'width')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="dif" prop="height" label-width="10px">
              *
              <el-input
                v-model="form.height"
                style="padding-left: 6px; box-sizing: border-box"
                placeholder="请输入车辆高度"
                clearable
                @change="(value) => setkey(value, 'height')"
              />mm
            </el-form-item>
          </el-col>
        </el-col>
        <el-col v-if="reportProvinceName == 'jiangsu'" :span="12">
          <el-form-item label="车轴数" prop="axlenum">
            <el-input
              v-model="form.axlenum"
              placeholder="请输入车轴数"
              clearable
              maxlength="2"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆所有人" prop="owner">
            <el-input
              v-model="form.owner"
              placeholder="请输入车辆所有人"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆行驶证档案编号" prop="vehicleLicense">
            <el-input
              v-model="form.vehicleLicense"
              placeholder="请输入车辆行驶证档案编号"
              clearable
              @change="
                (value) => {
                  form.vehicleLicense = value.replace(/\W/g, '');
                }
              "
            />
            <div class="remarks">
              注:行驶证若不存在档案编号可填车籍地6位行政区域代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆行驶证到期日期" prop="vehicleLicenseDueDate">
            <el-date-picker
              v-model="form.vehicleLicenseDueDate"
              type="date"
              placeholder="请选择车辆行驶证到期日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="品牌型号" prop="brandModel">
            <el-input
              v-model="form.brandModel"
              placeholder="请输入品牌型号"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发动机号码" prop="engineNo">
            <el-input
              v-model="form.engineNo"
              placeholder="请输入发动机号码"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆使用性质" prop="useCharacter">
            <el-input
              v-model="form.useCharacter"
              placeholder="请输入车辆车辆使用性质"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="核定载人数" prop="approvedPassengers">
            <el-input
              v-model="form.approvedPassengers"
              placeholder="请输入核定载人数"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="整备质量" prop="unladenMass">
            <el-input
              v-model="form.unladenMass"
              placeholder="请输入整备质量"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆识别代号" prop="vin">
            <el-input
              v-model="form.vin"
              placeholder="请输入车辆识别代号"
              clearable
              @change="
                (value) => {
                  form.vin = value.replace(/\W/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="车辆行驶证发证机关"
            prop="vehicleIssuingOrganizations"
          >
            <el-input
              v-model="form.vehicleIssuingOrganizations"
              placeholder="请输入车辆行驶证发证机关"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆行驶证注册日期" prop="registerDate">
            <el-date-picker
              v-model="form.registerDate"
              type="date"
              placeholder="请选择车辆行驶证注册日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆行驶证发证日期" prop="issueDate">
            <el-date-picker
              v-model="form.issueDate"
              type="date"
              placeholder="请选择车辆行驶证发证日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>-->
      <!-- <el-row>  -->
      <!-- <el-col :span="12">
          <el-form-item label="是否挂靠车辆" prop="isLinked">
            <el-select v-model="form.isLinked" placeholder="请选择">
              <el-option
                v-for="item in isLinkedOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
      <!-- <el-col v-if="hasTaxOpen" :span="12">
          <el-form-item label="车辆实际所有人" prop="realOwner">
            <el-input v-model="form.realOwner" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col v-if="hasTaxOpen" :span="12">
          <el-form-item label="车辆品牌" prop="brand">
            <el-input v-model="form.brand" placeholder="请输入" clearable />
          </el-form-item>
        </el-col> -->
      <!-- <el-col :span="12">
          <el-form-item label="是否挂车" prop="isHasTrailer">
            <el-select v-model="form.isHasTrailer" placeholder="请选择">
              <el-option
                v-for="item in isHasTrailerOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
      <!-- </el-row> -->
      <!-- 挂车 -->
      <!-- <el-row v-if="compTrailer">
        <el-col v-if="!parentData.isDetail && submitShow" :span="24">
          <el-form-item label="挂车证件">
            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车行驶证正页照片',
                prefix: 'trailerVehicleLicense',
                form: form,
                suffix: 'Img',
              }"
              :parent-data="parentData"
              :required="!!requireData.trailerVehicleLicenseImg"
              @handleImgSuccess="trailerVehicleLicenseImgSuccess"
            />

            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车行驶证副页照片',
                prefix: 'trailerVehicleLicenseDeputyPage',
                form: form,
                suffix: 'Img',
              }"
              :parent-data="parentData"
              :required="!!requireData.trailerVehicleLicenseDeputyPageImg"
              @handleImgSuccess="trailerVehicleLicenseDeputyPageImgSuccess"
            />
            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车照片',
                prefix: 'trailerVehicle',
                form: form,
                suffix: 'Img',
              }"
              :parent-data="parentData"
              :required="!!requireData.trailerVehicleImg"
            />
            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车道路运输证照片',
                prefix: 'trailerRoadTransportCertificate',
                form: form,
                suffix: 'Img',
              }"
              :parent-data="parentData"
              :required="!!requireData.trailerRoadTransportCertificateImg"
            />
          </el-form-item>
        </el-col>
        <el-col v-else :span="24">
          <el-form-item label="挂车证件">
            <ImgReview
              lebal="挂车行驶证正页照片"
              :src="form.trailerVehicleLicenseImg"
              error="未上传"
            />
            <ImgReview
              lebal="挂车行驶证副页照片"
              :src="form.trailerVehicleLicenseDeputyPageImg"
              error="未上传"
            />
            <ImgReview
              lebal="挂车照片"
              :src="form.trailerVehicleImg"
              error="未上传"
            />
            <ImgReview
              lebal="挂车道路运输证照片"
              :src="form.trailerRoadTransportCertificateImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>

        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车车牌号" prop="trailerNum">
            <el-input
              v-model="form.trailerNum"
              placeholder="请输入挂车车牌号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="挂车车牌颜色" prop="trailerLicenseColor">
            <el-select
              v-model="form.trailerLicenseColor"
              placeholder="请选择挂车车牌颜色"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleLicenseColorList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="挂车车辆类型" prop="trailerClassificationCode">
            <el-select
              v-model="form.trailerClassificationCode"
              placeholder="请选择挂车车辆类型"
              clearable
              filterable
            >
              <el-option
                v-for="item in parentData.vehicleClassificationList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车总质量(kg)" prop="trailerTotalWeight">
            <el-input
              v-model="form.trailerTotalWeight"
              placeholder="请输入挂车总质量"
              @change="(value) => setkey(value, 'trailerTotalWeight')"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车核定载质量(kg)" prop="trailerLoadWeight">
            <el-input
              v-model="form.trailerLoadWeight"
              placeholder="请输入挂车核定载质量"
              @change="(value) => setkey(value, 'trailerLoadWeight')"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车道路运输证号" prop="trailerRoadTransport">
            <el-input
              v-model="form.trailerRoadTransport"
              placeholder="请输入挂车道路运输证号"
              @change="
                (value) => {
                  form.trailerRoadTransport = value.replace(/\W/g, '');
                }
              "
            />
            <div class="remarks">
              总质量4.5吨及以下普通货运车辆可填车籍地6位行政区代码+000000
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- 上传 道路运输证照片-->
      <!-- <el-row v-if="!parentData.isDetail && submitShow">
        <el-col :span="24">
          <el-form-item label="车辆证件">
            <div style="display: inline-block">
              <ImgUpload
                :upload-config="{
                  lebal: '道路运输证照片',
                  prefix: 'roadTransportCertificate',
                  form: form,
                  suffix: 'Img',
                }"
                :parent-data="parentData"
                :required="!!requireData.roadTransportCertificateImg"
                @handleImgSuccess="roadTransportCertificateSuccess"
              />
            </div>
            <div style="display: inline-block">
              <ImgUpload
                v-if="hasTaxOpen"
                :upload-config="{
                  lebal: '车主声明',
                  prefix: 'state',
                  form: form,
                  suffix: 'Img',
                }"
                :parent-data="parentData"
                :required="!!requireData.stateImg"
              />
            </div>
            <div style="display: inline-block">
              <ImgUpload
                v-if="form.isLinked"
                :upload-config="{
                  lebal: '挂靠协议照片',
                  prefix: 'depenDeal',
                  form: form,
                  suffix: 'Img',
                }"
                :required="true"
                :parent-data="parentData"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- 详情图片选择 -->
      <!-- <el-row v-else>
        <el-col :span="24">
          <el-form-item label="车辆证件">
            <div style="display: inline-block">
              <ImgReview
                lebal="道路运输证照片"
                :src="form.roadTransportCertificateImg"
                error="未上传"
              />
            </div>
            <div style="display: inline-block">
              <ImgReview
                v-if="hasTaxOpen"
                lebal="车主声明"
                :src="form.stateImg"
                error="未上传"
              />
            </div>
            <ImgReview
              v-if="hasTaxOpen && form.isLinked == 1"
              lebal="挂靠协议照片"
              :src="form.depenDealImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item
            label="车辆道路运输证号"
            prop="roadTransportCertificateNumber"
          >
            <el-input
              v-model="form.roadTransportCertificateNumber"
              placeholder="请输入车辆道路运输证号"
              clearable
              @change="
                (value) => {
                  form.roadTransportCertificateNumber = value.replace(
                    /\W/g,
                    ''
                  );
                }
              "
            />
            <div class="remarks">
              注:总质量4.5吨及以下普通货运车辆可填车籍地6位行政区域代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="经营许可证号(道路运输证)"
            prop="roadTransportPermitNumber"
          >
            <el-input
              v-model="form.roadTransportPermitNumber"
              placeholder="请输入经营许可证号"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输证经济类型" prop="economicType">
            <el-input
              v-model="form.economicType"
              placeholder="请输入道路运输证经济类型"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输证车辆类型"
            prop="typeRoadTransportVehicle"
          >
            <el-input
              v-model="form.typeRoadTransportVehicle"
              placeholder="请输入道路运输证车辆类型"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输证车辆吨位(吨)" prop="shippingTon">
            <el-input
              v-model="form.shippingTon"
              placeholder="请输入道路运输证车辆吨位"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输证经营范围"
            prop="businessScopeTransportation"
          >
            <el-input
              v-model="form.businessScopeTransportation"
              placeholder="请输入道路运输证经营范围"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输证到期日期"
            prop="roadTransportCertificateDate"
          >
            <el-date-picker
              v-model="form.roadTransportCertificateDate"
              type="date"
              placeholder="请选择道路运输证到期日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col v-if="reportProvinceName == 'liaoning'" :span="12">
          <el-form-item
            label="车辆道路运输证字"
            prop="roadTransportCertificateWord"
          >
            <el-input
              v-model="form.roadTransportCertificateWord"
              placeholder="请输入车辆道路运输证字"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- 总重量<=4.5吨(必填) -->
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="车辆总质量<=4.5吨必填项">
            <el-switch v-model="showExtra" :disabled="disabled" />
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- 其他 -->
      <!-- <el-row v-if="!parentData.isDetail && submitShow">
        <el-col :span="24">
          <el-form-item label="其他上传">
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人半身照',
                prefix: 'driver',
                form: form,
                suffix: 'Img',
              }"
              :parent-data="parentData"
              :required="!!requireData.driverImg"
            />
            <div style="display: inline-block">
              <ImgUpload
                :upload-config="{
                  lebal: '安全责任险照片',
                  prefix: 'safeDutyInsure',
                  form: form,
                  suffix: 'Img',
                  isRequired: false,
                }"
                :required="!!requireData.safeDutyInsureImg"
                :parent-data="parentData"
              />
            </div>
            <div style="display: inline-block">
              <ImgUpload
                :upload-config="{
                  lebal: '车辆照片',
                  prefix: 'vehicle',
                  form: form,
                  suffix: 'Img',
                }"
                :parent-data="parentData"
                :required="!!requireData.vehicleImg"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row v-else>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <ImgReview
              lebal="实际承运人半身照"
              :src="form.driverImg"
              error="未上传"
            />
            <div style="display: inline-block">
              <ImgReview
                lebal="安全责任险照片"
                :src="form.safeDutyInsureImg"
                error="未上传"
              />
            </div>
            <div style="display: inline-block">
              <ImgReview
                lebal="车辆照片"
                :src="form.vehicleImg"
                error="未上传"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row v-if="otherItems">
        <el-col :span="12">
          <el-form-item label="车辆能源类型" prop="vehicleEnergyType">
            <el-select
              v-model="form.vehicleEnergyType"
              placeholder="请选择车辆能源类型"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleEnergyTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车牌颜色" prop="vehicleLicenseColor">
            <el-select
              v-model="form.vehicleLicenseColor"
              placeholder="请选择车牌颜色"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleLicenseColorList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
      <!-- <el-col :span="12">
          <el-form-item label="车身自重(kg)" prop="selfRespect">
            <el-input
              v-model="form.selfRespect"
              placeholder="请输入车身自重"
              clearable
              @change="(value) => setkey(value, 'selfRespect')"
            />
          </el-form-item>
        </el-col> -->
      <!-- <el-col v-if="hasTaxOpen" :span="12">
          <el-form-item label="车辆实际所有人联系电话" prop="realOwnerPhone">
            <el-input
              v-model="form.realOwnerPhone"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
        </el-col> -->
      <!-- <el-col :span="12">
          <el-form-item label="定位来源" prop="locationSource">
            <el-select
              v-model="form.locationSource"
              placeholder="请选择定位来源"
            >
              <el-option
                v-for="item in parentData.locationSourceList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
      <!-- <el-col :span="24">
          <el-form-item />
        </el-col>
      </el-row> -->
    </el-form>
    <el-button
      v-if="!parentData.isDetail && submitShow"
      type="primary"
      plain
      @click="funcSubmit()"
    >
      提交
    </el-button>
  </div>
</template>
<script>
import {
  getDriverTeam,
  getDriverInfo,
  updateDriverTeam,
  isTaxOpen
} from "@/api/driver.js";
import {
  validatePhone,
  validateIDNumber,
  validateCarNum
} from "@/utils/validate.js";
import { findByFieldFrom } from "@/api/required";
import ImgUpload from "@/components/ImgUpload";
import ImgReview from "@/components/ImgReview";
import { getOcr } from "@/api/shipment";
import { realDay } from "@/utils/validate";
import { maxNumber, checkPassword } from "@/utils/validate4Form.js";
export default {
  name: "DriverEdit",
  components: {
    ImgUpload,
    ImgReview
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          areaOptions: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          vehicleLicenseColorList: [],
          vehicleEnergyTypeList: []
        };
      }
    }
  },
  data() {
    return {
      showExtra: true,
      hasTaxOpen: "",
      otherItems: true,
      linkageInvalid: true,
      submitShow: true,
      form: {
        stateImg: "",
        identificationImg: "",
        identificationBackImg: "",
        driverImg: "",
        driverLicenseImg: "",
        workLicenseImg: "",
        safeDutyInsureImg: "",
        vehicleLicenseImg: "",
        vehicleLicenseDeputyPageImg: "",
        roadTransportCertificateImg: "",
        vehicleImg: "",
        roadPermitNumberImg: ""
      },
      hisForm: {},
      ficationImgRes: {},
      driverLicenseRes: {},
      // 必填功能
      isAdmin: false,
      sex: "1",
      requireData: {},
      reportProvinceName: "",
      // 挂车
      isHasTrailerOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      // 挂靠车辆
      isLinkedOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 校验
      rules: {
        roadPermitNumber: [
          {
            required: false,
            message: "请输入道路经营许可证号",
            trigger: "blur"
          },
          { max: 64, message: "最大长度为64个字符" }
        ],
        vehicleLicenseColor: [
          { required: false, message: "请选择车牌颜色", trigger: "change" }
        ],
        vehicleEnergyType: [
          { required: false, message: "请选择车辆能源类型", trigger: "change" }
        ],
        name: [
          { required: false, message: "请输入姓名", trigger: "blur" },
          { max: 64, message: "长度不能超过64个字符" }
        ],
        sex: [{ required: false, message: "请选择性别", trigger: "blur" }],
        driverIssuingOrganizations: [
          {
            required: false,
            message: "请输入机动车驾驶证发证机关",
            trigger: "blur"
          },
          { max: 255, message: "长度不能超过255个字符" }
        ],
        vehicleIssuingOrganizations: [
          {
            required: false,
            message: "请输入车辆行驶证发证机关",
            trigger: "blur"
          },
          { max: 255, message: "长度不能超过255个字符" }
        ],
        driverLicenseFromDate: [
          {
            required: false,
            message: "请选择机动车驾驶证有效期开始日期",
            trigger: "change"
          }
        ],
        issueDate: [
          {
            required: false,
            message: "请选择车辆行驶证发证日期",
            trigger: "change"
          }
        ],
        useCharacter: [
          {
            required: false,
            message: "请输入车辆车辆使用性质",
            trigger: "blur"
          },
          { max: 255, message: "最大长度为255个字符" }
        ],
        identificationNumber: [
          {
            required: false,
            message: "请输入公民身份证号码",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              validateIDNumber(value)
                ? callback()
                : callback(new Error("请输入正确的公民身份证号码"));
            }
          }
        ],
        roadPermitName: [
          {
            required: false,
            message: "请输入道路经营许可证业户名称",
            trigger: "blur"
          },
          { max: 255, message: "最大长度为255个字符" }
        ],
        businessUniformSocialCreditCode: [
          {
            required: false,
            message: "请输入道路经营业户社会信用代码",
            trigger: "blur"
          },
          { max: 128, message: "最大长度为128个字符" }
        ],
        idCardDueDate: [
          {
            required: false,
            message: "请选择身份证有效日期",
            trigger: "change"
          }
        ],
        homeAddress: [
          { required: false, message: "请输入住址", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ],
        vehicleClass: [
          { required: false, message: "请选择准驾类型", trigger: "change" }
        ],
        annualReviewTime: [
          { required: false, message: "请选择年审时间", trigger: "change" }
        ],
        workLicense: [
          {
            required: false,
            message: "请输入道路运输从业资格证号",
            trigger: "blur"
          },
          { max: 128, message: "最大长度为128个字符" }
        ],
        workCompany: [
          { required: false, message: "请输入工作单位", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ],
        workLicenseDueDate: [
          {
            required: false,
            message: "请选择道路运输从业资格证到期日期",
            trigger: "change"
          }
        ],
        vehicleLicenseDueDate: [
          {
            required: false,
            message: "请选择车辆行驶证到期日期",
            trigger: "change"
          }
        ],
        registerDate: [
          {
            required: false,
            message: "请选择车辆行驶证注册日期",
            trigger: "change"
          }
        ],
        roadTransportCertificateDate: [
          {
            required: false,
            message: "请选择道路运输证到期日期",
            trigger: "change"
          }
        ],
        selfRespect: [
          { required: false, message: "请输入车身自重", trigger: "change" },
          { validator: maxNumber }
        ],
        totalWeight: [
          { required: false, message: "请选择车辆总质量", trigger: "change" },
          { validator: maxNumber }
        ],
        roadTransportCertificateWord: [
          {
            required: false,
            message: "请输入车辆道路运输证字",
            trigger: "blur"
          },
          { max: 64, message: "最大长度为64个字符" }
        ],
        height: [
          { required: false, message: "请选择车辆高度", trigger: "change" },
          { validator: maxNumber }
        ],
        width: [
          { required: false, message: "请选择车辆宽度", trigger: "change" },
          { validator: maxNumber }
        ],
        length: [
          { required: false, message: "请选择车辆长度", trigger: "change" },
          { validator: maxNumber }
        ],
        trailerNum: [
          {
            required: false,
            message: "请输入挂车车牌号",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              if (!value) {
                return callback();
              }
              validateCarNum(value)
                ? callback()
                : callback(new Error("请输入正确的挂车车牌号"));
            }
          }
        ],
        trailerLicenseColor: [
          { required: false, message: "请选择挂车车牌颜色", trigger: "change" }
        ],
        trailerClassificationCode: [
          { required: false, message: "请选择挂车车辆类型", trigger: "change" }
        ],
        trailerRoadTransport: [
          {
            required: false,
            message: "请输入挂车道路运输证号",
            trigger: "blur"
          },
          { max: 64, message: "最大长度为64个字符" }
        ],
        trailerTotalWeight: [
          { required: false, message: "请输入挂车总重量", trigger: "blur" },
          { validator: maxNumber }
        ],
        trailerLoadWeight: [
          { required: false, message: "请输入挂车核定载质量", trigger: "blur" },
          { validator: maxNumber }
        ],
        isHasTrailer: [
          { required: false, message: "请选择是否挂车", trigger: "change" }
        ],
        driverLicenseDueDate: [
          {
            required: false,
            message: "请选择驾驶证有效期结束日期",
            trigger: "change"
          }
        ],
        areaList: [
          { required: false, message: "请选择通信地址", trigger: "change" }
        ],
        driverLicense: [
          { required: false, message: "请输入机动车驾驶证号", trigger: "blur" },
          { max: 128, message: "最大长度为128个字符" }
        ],
        vehicleLicense: [
          {
            required: false,
            message: "请输入车辆行驶证档案编号",
            trigger: "blur"
          },
          { max: 32, message: "最大长度为32个字符" }
        ],
        owner: [
          { required: false, message: "请输入车辆所有人", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ],
        axlenum: [
          { required: false, message: "请输入车轴数", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ],
        licenseNumber: [
          {
            required: true,
            validator(rule, value, callback) {
              validateCarNum(value)
                ? callback()
                : callback(new Error("请输入正确的车辆牌照号"));
            }
          }
        ],
        loadWeight: [
          {
            required: false,
            message: "请输入车辆核定载质量",
            trigger: "change"
          },
          { validator: maxNumber }
        ],
        roadTransportCertificateNumber: [
          {
            required: false,
            message: "请输入车辆道路运输证号",
            trigger: "blur"
          },
          { max: 32, message: "最大长度为32个字符" }
        ],
        vin: [
          {
            required: false,
            message: "请输入车辆识别代号",
            trigger: "blur"
          },
          { max: 255, message: "最大长度为255个字符" }
        ],
        classificationCode: [
          { required: false, message: "请选择车辆类型", trigger: "change" }
        ],
        realOwnerPhone: [
          {
            required: false,
            message: "请输入车辆实际所有人联系电话",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              if (!value) {
                return callback();
              }
              validatePhone(value)
                ? callback()
                : callback(new Error("请输入正确的联系方式"));
            }
          }
        ],
        phone: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("请输入正确的联系方式"));
            }
          }
        ],
        password: [
          { required: false, message: "请输入密码", trigger: "blur" },
          { validator: checkPassword }
        ],
        isLinked: [
          {
            required: true,
            message: "请选择是否挂靠车辆",
            trigger: "change"
          }
        ],
        realOwner: [
          {
            required: false,
            message: "请输入车辆实际所有人",
            trigger: "blur"
          },
          { max: 64, message: "最大长度为64个字符" }
        ],
        brand: [
          { required: false, message: "请输入车辆品牌", trigger: "blur" },
          { max: 200, message: "最大长度为200个字符" }
        ],
        fileNo: [
          { required: true, message: "请输入档案编号", trigger: "change" }
        ],

        firstIssueDate: [
          {
            required: true,
            message: "请选择机动车驾驶证初次领证日期",
            trigger: "change"
          }
        ],
        brandModel: [
          { required: true, message: "请输入品牌型号", trigger: "change" }
        ],
        engineNo: [
          { required: true, message: "请输入发动机号码", trigger: "change" }
        ],
        approvedPassengers: [
          { required: true, message: "请输入核定载人数", trigger: "change" },
          { validator: maxNumber }
        ],
        unladenMass: [
          { required: true, message: "请输入整备质量", trigger: "change" },
          { validator: maxNumber }
        ],
        roadTransportPermitNumber: [
          {
            required: true,
            message: "请输入经营许可证号(道路运输证)",
            trigger: "change"
          }
        ],
        economicType: [
          {
            required: true,
            message: "请输入道路运输证经济类型",
            trigger: "change"
          }
        ],
        typeRoadTransportVehicle: [
          {
            required: true,
            message: "请输入请输入道路运输证车辆类型",
            trigger: "change"
          }
        ],
        shippingTon: [
          {
            required: true,
            message: "请输入道路运输证车辆吨位",
            trigger: "change"
          },
          { validator: maxNumber }
        ],
        businessScopeTransportation: [
          {
            required: true,
            message: "请输入道路运输证经营范围",
            trigger: "change"
          }
        ],
        businessScope: [
          {
            required: true,
            message: "请输入道路运输经营许可证经营范围",
            trigger: "change"
          }
        ],
        periodValidity: [
          {
            required: true,
            message: "请选择道道路运输经营许可证证件有效期",
            trigger: "change"
          }
        ],
        approvedDriving: [
          {
            required: true,
            message: "请输入道路运输从业资格证准驾车型",
            trigger: "change"
          }
        ],
        qualificationCategory: [
          {
            required: true,
            message: "请输入道路运输从业资格证从业资格类别",
            trigger: "change"
          }
        ],
        initialCertificationDate: [
          {
            required: true,
            message: "请选择道路运输从业资格证初次领证日期",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    compIsLinked() {
      return this.form.isLinked;
    },
    compTrailer() {
      return this.form.isHasTrailer === 1 ? true : false;
    },
    disabled() {
      let istrue =
        this.requireData.vehicleClass ||
        this.requireData.driverIssuingOrganizations ||
        this.requireData.driverLicenseFromDate ||
        this.requireData.vehicleClass ||
        this.requireData.vin ||
        this.requireData.useCharacter ||
        this.requireData.vehicleIssuingOrganizations ||
        this.requireData.registerDate ||
        this.requireData.issueDate;
      return !!istrue;
    }
  },
  watch: {
    compIsLinked(val) {
      // “是否挂靠”决定了“道路经营许可证业户名称”是否为必填
      this.rules.roadPermitName[0].required = !!val;
      if (!val) {
        this.$refs.form.clearValidate(["roadPermitName"]);
      }
    },
    // 监听路由刷新
    $route: function(route) {
      if (route.query.code && route.path.indexOf("infoDriverForm") > -1) {
        this.getDriverTeam();
      }
    },
    compTrailer(val) {
      this.$refs.form.clearValidate(["totalWeight", "loadWeight"]);
      this.rules.totalWeight[0].message = val
        ? "请输入车头整备质量"
        : "请输入车辆总质量";
      this.rules.loadWeight[0].message = val
        ? "请输入准牵引总质量"
        : "请输入核定载质量";
    }
  },
  created() {
    this.reportProvinceName = this.reportProvince();
    // const partyType = this.$store.getters.party.partyType
    // this.isDriver = partyType == 'DRIVER' || partyType == 'DRIVER_LEADER'
    // this.isAdmin = partyType == 'SUPER_ADMIN' || partyType == 'PLAT_ADMIN' || partyType == 'STAFF'
    this.findByFieldFrom();
    const code = this.$route.query.code;
    this.form = {
      state: "",
      identificationImg: "",
      identificationBackImg: "",
      driverImg: "",
      driverLicenseImg: "",
      workLicenseImg: "",
      safeDutyInsureImg: "",
      vehicleLicenseImg: "",
      vehicleLicenseDeputyPageImg: "",
      roadTransportCertificateImg: "",
      vehicleImg: "",
      roadPermitNumberImg: ""
    };
    isTaxOpen().then(res => {
      this.hasTaxOpen = res.data;
    });
    if (code) {
      this.getDriverTeam();
    } else {
      // 实际承运人权限
      getDriverInfo().then(response => {
        this.form = Object.assign({}, response.data, response.data.vehicleVO);
        this.hisForm = response.data;
        this.$set(this.form, "areaList", []);
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        this.$set(
          this.form,
          "hasDriverDueDate",
          this.form.driverLicenseDueDate == "9999-12-31"
        );
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
        // 避开第一次联动操作
        setTimeout(() => {
          this.linkageInvalid = false;
        }, 500);
        if (this.form.driverType > 1) {
          this.submitShow = false;
        }
      });
    }
  },
  methods: {
    isVehicleType(val) {
      const TypeList = this.parentData.vehicleClassificationList.filter(
        item => item.code == val
      );
      if (TypeList[0].name.includes("牵引")) {
        this.$set(this.form, "isHasTrailer", 1);
      } else {
        this.$set(this.form, "isHasTrailer", 0);
      }
    },
    findList() {},
    getDriverTeam() {
      // 管理员权限
      const code = this.$route.query.code;
      getDriverTeam(code).then(response => {
        this.form = Object.assign({}, response.data, response.data.vehicleVO);
        this.hisForm = response.data;
        this.form.code = code;
        this.showExtra = !!(
          this.form.vehicleClass ||
          this.form.driverIssuingOrganizations ||
          this.form.driverLicenseFromDate ||
          this.form.vin ||
          this.form.useCharacter ||
          this.form.vehicleIssuingOrganizations ||
          this.form.registerDate ||
          this.form.issueDate
        );
        this.$set(this.form, "areaList", []);
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        this.$set(
          this.form,
          "hasDriverDueDate",
          this.form.driverLicenseDueDate == "9999-12-31"
        );
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
        // 避开第一次联动操作
        setTimeout(() => {
          this.linkageInvalid = false;
        }, 500);
        if (this.form.driverType > 1) {
          this.submitShow = false;
        }
      });
    },
    // 设置重量小数点后三位
    setkey(value, key) {
      this.$set(
        this.form,
        key,
        value.replace(/\.[0-9]+/g, "").replace(/\D/g, "")
      );
    },
    // 查询必填项
    async findByFieldFrom() {
      let response = await findByFieldFrom({ fieldFrom: "driver" });
      this.requireData = response.data;
      for (let key in this.requireData) {
        if (this.rules[key])
          this.rules[key][0].required = !!this.requireData[key];
      }
      this.rules.password[0].required = false;
      this.rules.width[0].required = this.requireData.dimension;
      this.rules.height[0].required = this.requireData.dimension;
      this.rules.length[0].required = this.requireData.dimension;
    },
    // 设置必填
    setQuired(key) {
      if (key == "dimension") {
        this.rules.width[0].required = this.requireData.dimension;
        this.rules.height[0].required = this.requireData.dimension;
        this.rules.length[0].required = this.requireData.dimension;
        return;
      }
      this.rules[key][0].required = !!this.requireData[key];
    },
    // 区域切换
    changeAreaList(value) {
      if (value.length > 0) {
        this.form.provinceCode = value[0];
        this.form.cityCode = value[1];
        this.form.countyCode = value[2];
      } else {
        this.form.provinceCode = "";
        this.form.cityCode = "";
        this.form.countyCode = "";
      }
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 修改
          const isDriverLicenseDateError =
            this.form.driverLicenseFromDate >= this.form.driverLicenseDueDate;
          // isDateError = this.form.registerDate > this.form.issueDate;
          if (isDriverLicenseDateError) {
            this.$message({
              message: "请选择正确的驾驶证有效日期范围",
              type: "error"
            });
            return false;
          }
          // if (isDateError) {
          //   this.$message({
          //     message: "请选择正确的注册日期和发证日期",
          //     type: "error"
          //   });
          //   return false;
          // }
          if (this.ficationImgRes.data && !this.driverLicenseRes.data) {
            if (
              this.ficationImgRes.data.name == this.hisForm.driverLicenseName
            ) {
              this.form.ocrResult = 0;
            } else {
              this.form.ocrResult = 1;
            }
          } else if (!this.ficationImgRes.data && this.driverLicenseRes.data) {
            if (this.driverLicenseRes.data.name == this.hisForm.name) {
              this.form.ocrResult = 0;
            } else {
              this.form.ocrResult = 1;
            }
          } else if (this.ficationImgRes.data || this.driverLicenseRes.data) {
            if (
              this.ficationImgRes.data.name == this.driverLicenseRes.data.name
            ) {
              this.form.ocrResult = 0;
            } else {
              this.form.ocrResult = 1;
            }
          }
          const rLoading = this.openLoading();
          this.form.vehicleDTO = {};
          for (const key in this.form) {
            if (key !== "vehicleVO" && key !== "vehicleDTO") {
              this.form.vehicleVO[key] = this.form[key];
            }
          }
          if (this.form.isHasTrailer !== 1) {
            this.form.trailerRoadTransportCertificateImg = "";
            this.form.trailerVehicleImg = "";
            this.form.trailerVehicleLicenseImg = "";
            this.form.trailerNum = "";
            this.form.trailerRoadTransport = "";
          }
          setTimeout(() => {
            this.form.vehicleDTO = this.form.vehicleVO;
            updateDriverTeam(this.form).then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              const code = this.$route.query.code;
              if (code) {
                this.$router.push({
                  path: "/driver/driverManage"
                });
              } else {
                // 重新请求数据
                getDriverInfo().then(response => {
                  this.form = Object.assign(
                    {},
                    response.data,
                    response.data.vehicleVO
                  );
                  this.$set(this.form, "areaList", []);
                  if (
                    this.form.provinceCode &&
                    this.form.cityCode &&
                    this.form.countyCode
                  ) {
                    this.form.areaList.push(
                      this.form.provinceCode,
                      this.form.cityCode,
                      this.form.countyCode
                    );
                  }
                });
              }
            });
          }, 500);
        }
        // else {
        //   this.$message.error("必选项为空或格式不正确");
        // }
      });
    },
    // 身份证正面识别
    async ficationImgSuccess(url) {
      this.ficationImgRes = await getOcr({
        image: url,
        ocrType: "ocrIdidentityCardFront"
      });
      let data = this.ficationImgRes.data;
      data.name ? this.$set(this.form, "name", data.name) : null;
      if (this.ficationImgRes.data) {
        if (data.name != this.driverLicenseRes.name) {
          this.$message({
            message: "上传的身份证与驾驶证姓名不匹配",
            type: "warning"
          });
        }
      } else {
        if (this.hisForm.driverLicenseName) {
          if (data.name != this.hisForm.driverLicenseName) {
            setTimeout(() => {
              this.$message({
                message: "上传的身份证与驾驶证姓名不匹配",
                type: "warning"
              });
            }, 1000);
          }
        }
      }
      data.identity
        ? this.$set(this.form, "identificationNumber", data.identity)
        : null;
      data.address ? this.$set(this.form, "homeAddress", data.address) : null;
      if (data.provinceCode) {
        this.$set(this.form, "provinceCode", data.provinceCode);
        this.$set(this.form, "cityCode", data.cityCode);
        this.$set(this.form, "countyCode", data.countyCode);
        this.$set(this.form, "areaList", [
          data.provinceCode,
          data.cityCode,
          data.countyCode
        ]);
      }
    },
    // 身份证反面识别
    async ficationImgBackSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrIdidentityCardFrontBack"
      });
      let data = res.data;
      if (data.expiryDate == "长期" || data.expiryDate == "9999-12-31") {
        this.$set(this.form, "hasDueDate", true);
        this.$set(this.form, "idCardDueDate", "9999-12-31");
      } else if (data.expiryDate) {
        let time = data.expiryDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let expiryDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "idCardDueDate", expiryDate);
          this.$set(this.form, "hasDueDate", false);
        }
      }
    },
    // 驾驶证正面识别
    async driverLicenseSuccess(url) {
      this.driverLicenseRes = await getOcr({
        image: url,
        ocrType: "ocrDrivingLicense"
      });
      let data = this.driverLicenseRes.data;
      if (this.driverLicenseRes.msg == "请确认上传驾驶证件是否正确") {
        this.$message({
          message: this.driverLicenseRes.msg,
          type: "warning"
        });
      }
      if (this.ficationImgRes.data) {
        if (data.name != this.ficationImgRes.data.name) {
          setTimeout(() => {
            this.$message({
              message: "上传的驾驶证与身份证姓名不匹配",
              type: "warning"
            });
          }, 1000);
        }
      } else {
        if (this.hisForm.name) {
          if (data.name != this.hisForm.name) {
            setTimeout(() => {
              this.$message({
                message: "上传的驾驶证与身份证姓名不匹配",
                type: "warning"
              });
            }, 1000);
          }
        }
      }
      data.certificateNumber
        ? this.$set(this.form, "driverLicense", data.certificateNumber)
        : null;
      data.orgOfIssue
        ? this.$set(this.form, "driverIssuingOrganizations", data.orgOfIssue)
        : null;
      // 机动车驾驶证初次领证日期
      if (data.firstDate) {
        let time = data.firstDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let validStartDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "firstIssueDate", validStartDate);
        }
      }
      if (data.validStartDate) {
        let time = data.validStartDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let validStartDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "driverLicenseFromDate", validStartDate);
        }
      }
      if (data.validDate == "长期" || data.validDate == "9999-12-31") {
        this.$set(this.form, "hasDriverDueDate", true);
        this.$set(this.form, "driverLicenseDueDate", "9999-12-31");
      } else if (data.validDate) {
        let time = data.validDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let validDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "driverLicenseDueDate", validDate);
          this.$set(this.form, "hasDriverDueDate", false);
        }
      }
      this.parentData.vehicleTypeAllowList.map((item, index) => {
        if (item.name == data.canDrivingType) {
          this.$set(this.form, "vehicleClass", data.vehicleClass);
        }
      });
    },
    // 驾驶证副页识别
    async driverLicenseBackSuccess(url) {
      this.ocrDrivingLicenseFY = await getOcr({
        image: url,
        ocrType: "ocrDrivingLicenseFY"
      });
      let data2 = this.ocrDrivingLicenseFY.data;
      if (this.ocrDrivingLicenseFY.msg == "请确认上传驾驶证件是否正确") {
        this.$message({
          message: this.ocrDrivingLicenseFY.msg,
          type: "warning"
        });
      }
      data2.fileNo ? this.$set(this.form, "fileNo", data2.fileNo) : null;
    },
    // 行驶证正页识别
    async vehicleLicenseSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrVehicleLicense" });
      let data = res.data;
      data.plateNumber
        ? this.$set(this.form, "licenseNumber", data.plateNumber)
        : null;
      data.fileNumber
        ? this.$set(this.form, "vehicleLicense", data.fileNumber)
        : null;
      // 品牌型号
      data.brandModel
        ? this.$set(this.form, "brandModel", data.brandModel)
        : null;
      //车辆行驶证发证机关
      data.orgOfIssue
        ? this.$set(this.form, "vehicleIssuingOrganizations", data.orgOfIssue)
        : null;
      // 发动机号码
      data.engineNumber
        ? this.$set(this.form, "engineNo", data.engineNumber)
        : null;
      data.useNature
        ? this.$set(this.form, "useCharacter", data.useNature)
        : null;
      data.identificationNumber
        ? this.$set(this.form, "vin", data.identificationNumber)
        : null;
      data.owner ? this.$set(this.form, "owner", data.owner) : null;
      if (data.registrationDate) {
        let time = data.registrationDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let registrationDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "registerDate", registrationDate);
        }
      }
      if (data.dateOfIssue) {
        let time = data.dateOfIssue.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let dateOfIssue =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "issueDate", dateOfIssue);
        }
      }
    },
    // 行驶证副页识别
    async vehicleLicenseBackSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrVehicleLicenseBack" });
      let data = res.data;
      data.fileNumber
        ? this.$set(this.form, "vehicleLicense", data.fileNumber)
        : null;
      data.passengersCapacity
        ? this.$set(this.form, "approvedPassengers", data.passengersCapacity)
        : null;
      let loadWeight = "",
        totalWeight = "";
      if (data.totalMass || data.loadCapacity) {
        // 若识别出“总质量”和“核定载质量”，则设置“是否挂车”为“否”
        loadWeight = data.totalMass || loadWeight;
        totalWeight = data.loadCapacity || totalWeight;
        this.$set(this.form, "isHasTrailer", 0);
      }
      if (data.tractionMass || data.curbWeight) {
        // 若识别出“整备质量”和“准牵引总质量”，则设置“是否挂车”为“是”
        loadWeight = data.tractionMass || loadWeight;
        totalWeight = data.curbWeight || totalWeight;
        this.$set(this.form, "isHasTrailer", 1);
      }
      // 车辆行驶证到期日
      if (data.inspectionRecord) {
        let time = data.inspectionRecord.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let inspectionRecord =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "vehicleLicenseDueDate", inspectionRecord);
        }
      }
      // 整备质量
      data.curbWeight
        ? this.$set(
            this.form,
            "unladenMass",
            data.curbWeight.replace(/\D/g, "")
          )
        : null;
      // 核定载人数
      data.passengersCapacity
        ? this.$set(
            this.form,
            "approvedPassengers",
            data.passengersCapacity.replace(/\D/g, "")
          )
        : null;
      loadWeight
        ? this.$set(this.form, "loadWeight", loadWeight.replace(/\D/g, ""))
        : null;
      totalWeight
        ? this.$set(this.form, "totalWeight", totalWeight.replace(/\D/g, ""))
        : null;
      if (data.gabarite) {
        let gabarite = data.gabarite.replace(/mm|MM/, "");
        gabarite = gabarite.split("X");
        if (gabarite.length == 3) {
          this.$set(this.form, "length", gabarite[0]);
          this.$set(this.form, "width", gabarite[1]);
          this.$set(this.form, "height", gabarite[2]);
        }
      }
      if (data.fuelType) {
        let vehicleEnergyType = "";
        this.parentData.vehicleEnergyTypeList.forEach(function(item) {
          if (item.name == data.fuelType) {
            vehicleEnergyType = item.code;
          }
        });
        this.$set(this.form, "vehicleEnergyType", vehicleEnergyType);
      }
    },
    // 挂车行驶证正页
    async trailerVehicleLicenseImgSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrVehicleLicense" });
      let data = res.data;
      data.plateNumber
        ? this.$set(this.form, "trailerNum", data.plateNumber)
        : null;
      const item = this.parentData.vehicleClassificationList.find(
        ele => ele.name == data.vehicleType
      );
      this.$set(this.form, "trailerClassificationCode", item ? item.code : "");
    },
    // 挂车行驶证副页
    async trailerVehicleLicenseDeputyPageImgSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrVehicleLicenseBack" });
      let data = res.data;
      this.$set(
        this.form,
        "trailerLoadWeight",
        data.loadCapacity ? data.loadCapacity.replace(/\D/g, "") : ""
      );
      this.$set(
        this.form,
        "trailerTotalWeight",
        data.totalMass ? data.totalMass.replace(/\D/g, "") : ""
      );
    },
    // 挂车道路运输证识别
    async trailerTransportCertificateImgSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrRoadTransportCertificateFY"
      });
      let data = res.data;
      data.hao
        ? this.$set(
            this.form,
            "trailerRoadTransport",
            data.hao.replace(/\u53f7/g, "")
          )
        : null;
    },
    // 从业资格证识别
    async workLicenseSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrQualificationCertificate"
      });
      let data = res.data;
      data.zhenghao ? this.$set(this.form, "workLicense", data.zhenghao) : null;
      // 准驾车型
      data.zhunjiachexing
        ? this.$set(this.form, "approvedDriving", data.zhunjiachexing)
        : null;
      // 从业资格类别
      data.congyezigeleibie
        ? this.$set(this.form, "qualificationCategory", data.congyezigeleibie)
        : null;
      // 道路运输从业资格证初次领证日期
      if (data.chucilingzhengriqi) {
        let time = data.chucilingzhengriqi.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let validStartDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "initialCertificationDate", validStartDate);
        }
      }
      if (data.youxiaoqixian) {
        let time = data.youxiaoqixian.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let value =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "workLicenseDueDate", value);
        }
      }
    },
    // 道路运输证识别
    async roadTransportCertificateSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrRoadTransportCertificateFY"
      });
      // let res = await getOcr({
      //   image: url,
      //   ocrType: "ocrRoadTransportCertificate"
      // });
      let data = res.data;
      // let fuyedata = fuye.data;
      // 道路运输证许可证号
      data.jingyingxukezhenghao
        ? this.$set(
            this.form,
            "roadTransportPermitNumber",
            data.jingyingxukezhenghao
          )
        : null;
      // 道路运输证许可证号
      data.dunwei ? this.$set(this.form, "shippingTon", data.dunwei) : null;
      // 经济类型
      data.jingjileixing
        ? this.$set(this.form, "economicType", data.jingjileixing)
        : null;
      // 经营范围
      data.businessScopeTransportation
        ? this.$set(
            this.form,
            "businessScopeTransportation",
            data.businessScopeTransportation
          )
        : null;
      // 道路运输证车辆类型
      data.cheliangleixing
        ? this.$set(this.form, "typeRoadTransportVehicle", data.cheliangleixing)
        : null;
      data.hao
        ? this.$set(
            this.form,
            "roadTransportCertificateNumber",
            data.hao.replace(/\u53f7/g, "")
          )
        : null;
      if (data.roadTransportCertificateDate) {
        let time = data.roadTransportCertificateDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let value =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "roadTransportCertificateDate", value);
        }
      }
      if (data.cheliangleixing || data.cheliangleixing2) {
        let item = this.parentData.vehicleClassificationList.find(
          item =>
            item.name == data.cheliangleixing ||
            item.name == data.cheliangleixing2
        );
        item ? this.$set(this.form, "classificationCode", item.code) : null;
      }
      // data.chelianghaopai?this.$set( this.form ,'licenseNumber', data.chelianghaopai.replace(/\((.+)\)/g,'')):null
      let vehicleLicenseColor = data.chelianghaopai.match(/\(([^)]*)\)/)
        ? data.chelianghaopai.match(/\(([^)]*)\)/)[1]
        : null;
      if (vehicleLicenseColor) {
        this.parentData.vehicleLicenseColorList.map((item, index) => {
          if (item.name == vehicleLicenseColor) {
            this.$set(this.form, "vehicleLicenseColor", item.code);
          }
        });
      }
    },
    // 道路经营许可证照片
    async roadPermitNumberSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrRoadPermitNumber" });
      let data = res.data;
      data.hao ? this.$set(this.form, "roadPermitNumber", data.hao) : null;
      // 业户名称
      data.yehumingcheng
        ? this.$set(this.form, "roadPermitName", data.yehumingcheng)
        : null;
      data.jingyingfanwei
        ? this.$set(this.form, "businessScope", data.jingyingfanwei)
        : null;
      // 道路经营许可证照片证件有效期
      if (data.youxiaoqi_start && data.youxiaoqi_end) {
        let youxiaoqi = data.youxiaoqi_start + "-" + data.youxiaoqi_end;
        this.$set(this.form, "periodValidity", youxiaoqi);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.mode_box {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #f0f3f8;
  margin-top: 45px;
  overflow: hidden;
  margin-bottom: 18px;
  .card_info {
    width: 100%;
    height: 62px;
    line-height: 62px;
    background: #f0f3f8;
    border-radius: 0px 0px 0px 0px;
    font-weight: bold;
    font-size: 18px;
    color: #1169e9;
    padding-left: 15px;
    margin-bottom: 43px;
  }
}
.el-date-editor {
  width: 100%;
}
.remarks {
  color: #d01415;
  font-size: 12px;
}
::v-deep .dif {
  .el-form-item__content {
    display: flex;
    .el-input {
      flex: 1;
      margin-right: 20px;
    }
    .el-input:last-child {
      margin-right: 0;
    }
  }
}
.card_type_title {
  font-size: 19px;
  font-weight: bold;
  margin-left: 30px;
  margin-bottom: 20px;
}
::v-deep .el-tooltip__popper.is-dark {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 12px;
  border-radius: 4px;
}
</style>
/* eslint-enable no-console */
